import {Injectable} from '@angular/core';
import {GenericHandler} from '../generics/generic-handler';
import {UtilsService} from '../../utils/utils.service';
import {Auth2Service} from '../security/auth2.service';
import {Router} from '@angular/router';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Title} from '@angular/platform-browser';
import {GenericDatagridService} from '../generics/generic-datagrid.service';
import {MenuComposition__PlcDTO} from '../../dtos/menucomposition-plc-dto';
import {ObjectDTO} from '../../dtos/object-dto';
import {FormFieldBaseSupplier} from '../../suppliers/form-fieldbase-supplier';
import {DialogMsgSupplier} from '../../suppliers/dialog-msg-supplier';
import {Subject} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {DialogRecherchePlatsSupplier} from '../gestionmenus/menus-planning2.service';
import {MPlcRepasRow} from '../../models/plc-repas-row';

export const URL_POST_SAVE_EFFECTIF_PLAT_PLC = `dolrest/gestion-clients/point-de-livraison/plat/effectif/save`;
export const URL_POST_SAVE_TDP_PLAT_PLC = `dolrest/gestion-clients/point-de-livraison/plat/taux-de-prise/save`;
export const URL_GET_REMOVE_PLAT_PLC = `dolrest/gestion-clients/point-de-livraison/plat/remove`;
export const URL_GET_REINIT_PLAT_PLC = `dolrest/gestion-clients/point-de-livraison/plat/restore`;
export const URL_POST_SAVE_PLAT_PLC = `dolrest/gestion-clients/point-de-livraison/plat/save`;

@Injectable({
  providedIn: 'root'
})
export class MenucompositionPlcService extends GenericHandler<MenuComposition__PlcDTO> {

  private subjectChangeEffectif = new Subject<MenuComposition__PlcDTO>();
  changeEffectif$ = this.subjectChangeEffectif.asObservable();

  // changer le taux de prise
  private subjectChangeTdp = new Subject<MenuComposition__PlcDTO>();
  changeTdp$ = this.subjectChangeTdp.asObservable();

  // ajouter / modifier  un plat à partir de l'écran de recherche
  private subjectAddProduitDeclinaisonFromSearch = new Subject<DialogRecherchePlatsSupplier>();
  addProduitDeclinaisonFromSearch$ = this.subjectAddProduitDeclinaisonFromSearch.asObservable();

  constructor(utils: UtilsService,
              auth2Svc: Auth2Service,
              router: Router,
              http: HttpClient,
              title: Title,
              private gds: GenericDatagridService) {
    super(utils, auth2Svc, router, http, title);
  }

  createEmptyDTO = (): MenuComposition__PlcDTO => undefined;

  getAllFromEnvironnement = (): void => {
  };

  getCreateNewObjectLabel = (): string => "";

  getEditObjectLabel = (data: ObjectDTO): string => "";

  getEntityName = (): string => "MenuComposition__Plc";

  getFields = (dto: ObjectDTO): FormFieldBaseSupplier<any>[] => [];

  getHelp = (): DialogMsgSupplier => undefined;

  getOas = (): boolean => false;

  getSort = (): string[] => [];

  getTitle = (): string => "";

  getTotalRecordsLabel = (): string => "";

  announceChangeEffectifPlat = (plat: MenuComposition__PlcDTO) => {
    this.subjectChangeEffectif.next(plat);
  };

  announceChangeTdpPlat = (plat: MenuComposition__PlcDTO) => {
    this.subjectChangeTdp.next(plat);
  };

  saveEffectifPlatPlc = (mcPlc: MenuComposition__PlcDTO, typeEffectif: number) => {
    return this.http.post(URL_POST_SAVE_EFFECTIF_PLAT_PLC, mcPlc, {
      params: new HttpParams().set('typeEffectif', typeEffectif + '')
    })
      .pipe(
        catchError(error => this.utils.handleError(error))
      );

  };

  saveTauxDePrisePlatPlc = (mcPlc: MenuComposition__PlcDTO, typeEffectif: number) => {
    return this.http.post(URL_POST_SAVE_TDP_PLAT_PLC, mcPlc, {
      params: new HttpParams().set('typeEffectif', typeEffectif + '')
    })
      .pipe(
        catchError(error => this.utils.handleError(error))
      );

  };


  removePlat = (idMcPlc: number) => {
    return this.http.get(URL_GET_REMOVE_PLAT_PLC, {
      params: new HttpParams().set('idMenuCompositionPlc', idMcPlc + '')
    })
      .pipe(
        catchError(error => this.utils.handleError(error))
      );
  };

  reinitPlat = (idMcPlc: number) => {
    return this.http.get(URL_GET_REINIT_PLAT_PLC, {
      params: new HttpParams().set('idMenuCompositionPlc', idMcPlc + '')
    })
      .pipe(
        catchError(error => this.utils.handleError(error))
      );
  };

  announceProduitDeclinaisonFromSearch = (searchSupplier: DialogRecherchePlatsSupplier) => {
    this.subjectAddProduitDeclinaisonFromSearch.next(searchSupplier);
  };

  createMcPlc = (response: DialogRecherchePlatsSupplier) => {

    const mcPlc = new MenuComposition__PlcDTO();
    const row: MPlcRepasRow = response.sourceObject;

    mcPlc.cmcd = row.cmcd;
    mcPlc.actif = true;
    mcPlc.produitDeclinaison = response.produitsDeclinaisonsInCart[0];
    mcPlc.ordre = row.ordre;
    mcPlc.modificationManuelle = true;
    mcPlc.cmcrPlcDate = row.cmcrPlcDate;

    mcPlc.id = row.plat ? row.plat.id : 0;

    mcPlc.effectifPrevisionnel = row.plat && row.plat.effectifPrevisionnel ? row.plat.effectifPrevisionnel : 0;
    mcPlc.effectifFabrication = row.plat && row.plat.effectifFabrication ? row.plat.effectifFabrication : 0;
    mcPlc.effectifFacture = row.plat && row.plat.effectifFacture ? row.plat.effectifFacture : 0;

    mcPlc.tpEffectifPrevisionnel = row.plat && row.plat.tpEffectifPrevisionnel ? row.plat.tpEffectifPrevisionnel : 0;
    mcPlc.tpEffectifFabrication = row.plat && row.plat.tpEffectifFabrication ? row.plat.tpEffectifFabrication : 0;
    mcPlc.tpEffectifFacture = row.plat && row.plat.tpEffectifFacture ? row.plat.tpEffectifFacture : 0;

    mcPlc.aEffectifPrevisionnel = row.plat && row.plat.aEffectifPrevisionnel ?  row.plat.aEffectifPrevisionnel:false;
    mcPlc.aEffectifFabrication = row.plat && row.plat.aEffectifFabrication ? row.plat.aEffectifFabrication:false;
    mcPlc.aEffectifFacture = row.plat && row.plat.aEffectifFacture ? row.plat.aEffectifFacture:false;


    return mcPlc;

  };

  /**
   * Enregistrer un menu composition plc
   * @param mcPlc
   */
  save = (mcPlc: MenuComposition__PlcDTO) => {
    return this.http.post(URL_POST_SAVE_PLAT_PLC, mcPlc)
      .pipe(
        catchError(error => this.utils.handleError(error))
      );
  };
}
